export default __webpack_public_path__ + "static/media/banner-bg-small-mobile.9f8bff05.png";